import { ControlledSelect } from 'modules/common/components';
import Select from 'modules/common/components/Select';
import { Likes } from 'modules/donations/components/LikesSelect/enum';
import { ComponentProps, FC } from 'react';
import { UseControllerProps } from 'react-hook-form';
import { getTranslation } from 'utils/getTranslation';

type Props = {
  controlled: UseControllerProps<any>;
} & ComponentProps<typeof Select>;

const t = getTranslation('donation.LikesSelect');

const likesOptions = Object.values(Likes).map((value) => {
  return {
    value,
    label: t(value.charAt(0).toLowerCase() + value.slice(1)),
  };
});

export const LikesSelect: FC<Props> = ({ controlled, ...otherProps }) => {
  return (
    <ControlledSelect
      {...otherProps}
      options={likesOptions}
      defaultValue={undefined}
      controlled={controlled}
      placeholder={t('selectLikes')}
      mode="tags"
    />
  );
};
